<template>
<div>

    <div class="mb-4 flex justify-between">
        <h1 class="font-sans text-n-gray-dark">Categories</h1>

        <router-link class="pl-4 self-center" :to="{ name: 'category-create' }">
            Add a new category
        </router-link>

    </div>

    <div class="responsive-table">
    <table class="w-full">
        <thead>
            <tr>
                <th class="text-left p-2 border border-grey-light">Title</th>
                <th class="text-left p-2 border border-grey-light">Slug</th>
                <th class="text-left p-2 border border-grey-light">Group</th>
            </tr>
        </thead>
        <category-item
            v-for="category in categories"
            :key="category.id"
            :category="category" />
    </table>
    </div>
</div>
</template>

<script>

    import { mapGetters } from 'vuex'
    import CategoryItem from './CategoryItem.vue'

    export default {
        name: 'CategoryModule',
        title: 'Categories',
        components: {
            CategoryItem
        },
        computed: {
            ...mapGetters({
                categories: 'categories',
                categoryGroups: 'categoryGroups'
            })
        },
        mounted() {
            this.$store.dispatch('getCategories')
        }
    }
</script>
